import { useMutation } from "@tanstack/react-query";
import rolePermissionService from "../api/rolePermissionService";

export const useUpdateRolePermissions = () => {
  const { updateRolePermissions } = rolePermissionService();

  return useMutation({
    mutationKey: ["update-role-permissions"],
    mutationFn: async ({ rolePermissions }) => {
      const response = await updateRolePermissions(rolePermissions);
      return response.data;
    },
  });
};
